export function uniqueFilter() {
    return (arr, field) => _.uniqBy(arr, a => a[field]);
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/core/filters/unique/uniqueFilter.ts
 **/